import { Stack } from "@mui/material";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import GInput from "../html-elements/GInput.component";
import { PHIcons } from "../Icons/PHIcons";
import discoverImg from "../../assets/discover.svg";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import CookieManager from "../Cookies";
import { API_SSO, SetSSOToken } from "../../api/ssoapi/SSOapi";
import { Modal, Spin } from "antd";

import {
  getRememberMeDetails,
  performRememberMe,
} from "../../Utils/RememberMe.hooks";
import { CLocalStorage } from "../../constants/CLocalStorage";
import { CRoutePaths } from "../../constants/CApp";
import { useDebounce } from "../../hooks/debounce";
import Loader from "../Mangement/loader/Loader";

export const submitButtonStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  alignItems: "center",
  width: "400px",
  height: "48px",
  borderRadius: "6px",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "500",
  color: "white",
  backgroundColor: "#EC6C2A",
  border: "none",
  marginTop: "10px",
  outline: "none",
};

export const submitDisableButtonStyle: React.CSSProperties = {
  width: "400px",
  height: "48px",
  borderRadius: "6px",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "500",
  color: "white",
  backgroundColor: "#EC6C2A",
  border: "none",
  pointerEvents: "none",
  marginTop: "10px",
  opacity: "0.6",
  outline: "none",
};

const labelElement: React.CSSProperties = {
  color: "#000",
  fontSize: "14px",
  fontWeight: "400",
  fontFamily: "DiscoverSans-Medium",
  cursor: "pointer",
};
const inputDivStyle: React.CSSProperties = {
  minWidth: "400px",
  marginBottom: "10px",
};

const pwdInputDivStyle: React.CSSProperties = {
  minWidth: "400px",
  marginBottom: "8px",
};
const pwdInputErrDivStyle: React.CSSProperties = {
  minWidth: "400px",
  border: "1px solid #AD0303",
  marginBottom: "8px",
};
const otpInputDivStyle: React.CSSProperties = {
  minWidth: "400px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
const otpStyle: React.CSSProperties = {
  fontSize: "12px",
  fontWeight: "600",
  fontFamily: "DiscoverSans-Medium",
  cursor: "pointer",
  marginBottom: "3px",
};
const helperOtpStyle: React.CSSProperties = {
  fontSize: "12px",
  color: "#AD0303",
  fontWeight: "600",
  fontFamily: "DiscoverSans-Medium",
  cursor: "pointer",
  marginBottom: "3px",
};
const otpdivStyle: React.CSSProperties = {
  textAlign: "center",
  width: "93px",
  height: "42px",
  border: "1px solid #C4C4C4",
  borderRadius: "5px",
  outlineColor: "#EC6C2A",
};
const disabledDivStyle: React.CSSProperties = {
  minWidth: "395px",
  marginBottom: "16px",
  pointerEvents: "none",
  opacity: "0.6",
};
const rememberMeStyle: React.CSSProperties = {
  textAlign: "left",
  width: "100%",
  paddingBottom: "20px",
  fontFamily: "Open Sans",
  fontWeight: "400",
};
const checkBoxStyle: React.CSSProperties = {
  width: "18px",
  height: "17px",
  accentColor: "#EC6C2A",
};
const ArrowspanStyle: React.CSSProperties = {
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
  position: "relative",
  left: "13.2px",
  height: "42px",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: "rgb(236, 108, 42)",
  display: "flex",
  width: "40px",
  justifyContent: "center",
};
const eyeIcon: React.CSSProperties = {
  color: "#EC6C2A",
  fontSize: "18px",
  cursor: "pointer",
};
const ArrowIcon: React.CSSProperties = {
  color: "#fff",
  fontSize: "30px",
};
const DisabledeyeIcon: React.CSSProperties = {
  color: "#C4C4C4",
};
const DisabledArrowIcon: React.CSSProperties = {
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
  position: "relative",
  left: "13.2px",
  height: "42px",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: "rgb(236, 108, 42)",
  display: "flex",
  width: "40px",
  justifyContent: "center",
  opacity: "0.6",
};
const errorMsg: React.CSSProperties = {
  maxWidth: "300px",
  wordBreak: "break-word",
  fontSize: "12px",
  fontWeight: "600",
  fontFamily: "DiscoverSans-Medium",
  color: "#AD0303",
};
const forgotspanStyle: React.CSSProperties = {
  color: "#EC6C2A",
  fontSize: "13px",
  fontWeight: "600",
  fontFamily: "DiscoverSans-Medium",
  cursor: "pointer",
};
const generateOtpstyle: React.CSSProperties = {
  marginTop: "4px",
  color: "#EC6C2A",
  fontSize: "12px",
  fontWeight: "600",
  fontFamily: "DiscoverSans-Medium",
  cursor: "pointer",
};
const reGenerate: React.CSSProperties = {
  maxWidth: "402px",
  wordBreak: "break-word",
  fontSize: "12px",
  fontWeight: "600",
  fontFamily: "DiscoverSans-Medium",
  marginTop: "4px",
};

const AuthResults = {
  INVALID: 0,
  DONE: 1,
  OTP_AUTH_NEED: 2,
  SSO_AUTH_NEED: 3,
  PASSWORD_RESET_NEED: 4,
  ACCOUNT_LOCKED: 5,
  INCORRECT_PASSWORD: 6,
  EXPIRED: 7,
  PASS_RESTRICT: 200,
  SERVER_ERROR: 100,
};

interface ILoginData {
  userName: string;
  password: string;
  otp: string;
}
interface IPwdRes {
  result: number;
  isLoading: boolean;
  isFailed: boolean;
  token: string;
  limit: string;
}

interface IAuthSuc {
  result: boolean;
  token: string;
  canRoute: boolean;
}

interface IOtpConfig {
  isFirstOtpGenerated: boolean;
  isOtpEntered: boolean;
  isVisible: boolean;
}
interface Iloader {
  generateLoader: boolean;
  ArrowLoader: boolean;
  submitLoader: boolean;
}

const LoginForm = (props: { onEnableChangePwd: (emailID: string) => void }) => {
  const history = useHistory();
  let clientId: string =
    "U2FsdGVkX19oz6u1m94COncZ/FTnbPZhVUWw0vJhEED2/s3RuCRLhTu9SpDUIABr";

  const [isRememberme, SetRememberMe] = useState(false);
  const [loginData, setLoginData] = useState<ILoginData>({
    userName: "",
    password: "",
    otp: "",
  });

  const [helperText, setHelperText] = useState({
    userName: {
      error: false,
      text: "",
    },
    password: {
      error: false,
      text: "",
    },
    otp: {
      error: false,
      text: "",
    },
    passwordLimit: {
      error: false,
      text: "",
    },
  });

  const [isModalOpen, setModalOpen] = useState(false);
  const [isCookiePresent, setIsCookiePresent] = useState("");

  const [authenticationResult, setAuthenticationResult] = useState<any>({
    validatePassword: {
      result: -1,
      isLoading: false,
      error: null,
    },
    generateOtp: {
      res: null,
      isLoading: false,
      error: null,
    },
    validateOtp: {
      needOtpVal: false,
      result: -1,
      isLoading: false,
      error: null,
    },
  });
  const [passwordRes, setPasswordRes] = useState<IPwdRes>({
    isLoading: false,
    result: -1,
    isFailed: false,
    token: "",
    limit: "",
  });
  const [otpRes, setOtpRes] = useState<{ result: number; isLoading: boolean }>({
    isLoading: false,
    result: -1,
  });
  const [authSuccess, setAuthSuccess] = useState<IAuthSuc>({
    result: false,
    token: "",
    canRoute: false,
  });
  const [loading, setLoading] = useState<Iloader>({
    ArrowLoader: false,
    generateLoader: false,
    submitLoader: false,
  });
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);
  const [isPwdValidated, setPwdValidated] = useState(false);
  const [isOnlySuccessAuthSucc, setOnlySuccessAuthSucc] = useState(false);
  const [showPwdText, setShowPwdText] = useState(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [otpConfig, setOtpConfig] = useState<IOtpConfig>({
    isFirstOtpGenerated: false,
    isOtpEntered: false,
    isVisible: false,
  });

  useEffect(() => {
    if (
      passwordRes.result === AuthResults.OTP_AUTH_NEED &&
      loginData.otp?.length === 4
    ) {
      // setOtpEntered(true);
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: true,
        isVisible: true,
      });
      setLoading({
        ArrowLoader: false,
        generateLoader: false,
        submitLoader: false,
      });
      // setIsVisible(true);
    } else {
      if (otpConfig.isFirstOtpGenerated) {
        setOtpConfig({
          isFirstOtpGenerated: true,
          isOtpEntered: false,
          isVisible: true,
        });
      }
      // setOtpEntered(false);
    }
  }, [passwordRes.result, loginData.otp, isPwdValidated]);

  useEffect(() => {
    try {
      setLoading({
        ArrowLoader: true,
        submitLoader: false,
        generateLoader: false,
      });
      performRememberMe(CLocalStorage.Keys.RememberMe, {
        isEnabled: isRememberme,
        userName: loginData.userName,
        password: loginData.password,
      });
      if (passwordRes.result === AuthResults.DONE) {
        onLoginSuccess(loginData.userName, passwordRes.token);
      }
      setLoading({
        ArrowLoader: false,
        submitLoader: false,
        generateLoader: false,
      });
    } catch (error) {
      console.log(error);
    }
  }, [passwordRes]);

  const onLoginSuccess = (email: any, token: string) => {
    sessionStorage.setItem(CLocalStorage.Keys.Email, email);
    sessionStorage.setItem(CLocalStorage.Keys.Token, token);

    //localStorage.setItem(CLocalStorage.Keys.Email, email);
    //localStorage.setItem(CLocalStorage.Keys.Token, token);

    console.log(sessionStorage.getItem(CLocalStorage.Keys.Email));
    history.replace(CRoutePaths.Applications);
  };

  // for onBlur indicate username
  const onUserNameBlur = (lLoginData: ILoginData | undefined) => {
    var llogData = lLoginData !== undefined ? lLoginData : loginData;

    if (llogData.userName.trim().length === 0) {
      setHelperText({
        ...helperText,
        userName: { error: true, text: "Enter the UserName" },
      });
    } else {
      setHelperText({ ...helperText, userName: { error: false, text: "" } });
    }
    //checkPasswordValidation(llogData.userName,llogData.password);
  };

  // for onBlur indicate password
  const onPasswordBlur = (lLoginData: ILoginData | undefined) => {
    var llogData = lLoginData !== undefined ? lLoginData : loginData;
    if (llogData.password.trim().length === 0) {
      setHelperText({
        ...helperText,
        password: { error: true, text: "Enter the password" },
      });
    } else {
      setHelperText({ ...helperText, password: { error: false, text: "" } });
    }
    //checkPasswordValidation(llogData.userName,llogData.password);
  };

  // method for validatepassword
  const validatePassword = async (userName: string, password: string) => {
    setPasswordRes({
      result: -1,
      isLoading: true,
      isFailed: false,
      token: "",
      limit: "",
    });

    var passRes = {
      result: -1,
      isLoading: false,
      isFailed: false,
      token: "",
      limit: "",
    };
    try {
      var res = await API_SSO.ValidationPassword(userName, password);

      if (res.data?.result !== undefined) {
        passRes.result = res.data.result;
        passRes.token = res.data.token;
        passRes.limit = res.data.pwdLimit;
      }
    } catch (err) {
      console.error(err);
      passRes.result = AuthResults.SERVER_ERROR;
    }

    setPasswordRes(passRes);
  };

  // for checkpassword validation
  // const checkPasswordValidation = async (
  //   userName?: string,
  //   password?: string
  // ) => {
  //   var userN: string = "";
  //   var pwd: string = "";

  //   if (userName !== undefined && password !== undefined) {
  //     userN = userName;
  //     pwd = password;
  //   } else {
  //     userN = loginData.userName;
  //     pwd = loginData.password;
  //   }

  //   if (userN?.trim().length > 0 && pwd?.trim().length > 0) {
  //     await validatePassword(userN, pwd);
  //   }
  // };

  const checkPasswordValidation = async (
    userName?: string,
    password?: string
  ) => {
    var userN: string = "";
    var pwd: string = "";
    var passRes = {
      result: -1,
      isLoading: false,
      isFailed: false,
      token: "",
      limit: "0",
    } as IPwdRes;
    if (userName !== undefined && password !== undefined) {
      userN = userName;
      pwd = password;
    } else {
      userN = loginData.userName;
      pwd = loginData.password;
    }

    const trimmedPwd = pwd?.trim();
    const trimmedUserN = userN?.trim();

    if (trimmedUserN?.length > 0 && trimmedPwd?.length > 0) {
      if (trimmedPwd.length >= 8 && trimmedPwd.length <= 18) {
        await validatePassword(trimmedUserN, trimmedPwd);
      } else {
        passRes.result = AuthResults.PASS_RESTRICT;
        setPasswordRes(passRes);
      }
    }
  };

  // const checkPwdBounce = useDebounce(checkPasswordValidation, 500);

  // onChange handler for Username and Password
  const onChangeLoginDataHandler = (e: any) => {
    // setIsGenerate(false);
    setOtpConfig({
      isFirstOtpGenerated: false,
      isOtpEntered: false,
      isVisible: false,
    });

    var data = { ...loginData, [e.target.name]: e.target.value?.trim() };
    if (data.otp.trim() !== "") {
      data.otp = ""; // Reset OTP
    }
    setLoginData(data);

    if (e.target.name === "userName" || e.target.name === "password") {
      setPasswordRes({
        result: -1,
        isLoading: true,
        isFailed: false,
        token: "",
        limit: "",
      });
      // setIsVisible(false);
    }

    // onUserNameBlur(data);
    // onPasswordBlur(data);

    // if (e.target.name === "userName" || e.target.name === "password") {
    //   checkPwdBounce(data.userName, data.password);
    // }
    onOtpBlur(data);
  };

  // onChange handler for otp
  const onChangeOtpHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;
    if (value === "") {
      // Handle backspace
      const otpArray = loginData.otp.split("");
      otpArray[index] = value;
      const updatedOtp = otpArray.join("");
      setLoginData({ ...loginData, otp: updatedOtp });

      if (index > 0) {
        inputsRef.current[index - 1]?.focus();
      } // Call the blur function immediately to validate after change
      onOtpBlur({ ...loginData, otp: updatedOtp });
    } else if (/^\d$/.test(value)) {
      // Only allow single digit input
      const otpArray = loginData.otp.split("");
      otpArray[index] = value;
      const updatedOtp = otpArray.join("");
      setLoginData({ ...loginData, otp: updatedOtp });
      if (index < 3) {
        inputsRef.current[index + 1]?.focus();
      } // Call the blur function immediately to validate after change
      onOtpBlur({ ...loginData, otp: updatedOtp });
    } else {
      e.target.value = "";
    } // Clear invalid input
  };

  var numReg = /^\d+$/;

  // onBlur handler for otp
  const onOtpBlur = (lLoginData: ILoginData | undefined) => {
    const llogData = lLoginData !== undefined ? lLoginData : loginData;
    if (llogData.otp.trim().length !== 4) {
      setHelperText({
        ...helperText,
        otp: { error: true, text: "Enter the full 4-digit OTP" },
      });
    } else if (!numReg.test(llogData.otp.trim())) {
      setHelperText({
        ...helperText,
        otp: { error: true, text: "Enter a valid OTP" },
      });
    } else {
      setHelperText({ ...helperText, otp: { error: false, text: "" } });
      // setOtpEntered(true);
      setOtpConfig({
        isFirstOtpGenerated: true,
        isOtpEntered: true,
        isVisible: true,
      });
    }
  };

  // useEffect hook for set OnlySuccessAuthSucc and PwdValidated based on passwordRes.result
  useEffect(() => {
    var isValid = false;
    var isAuthScc = false;
    if (passwordRes.result === AuthResults.DONE) {
      isValid = true;
      setAuthSuccess({
        result: true,
        token: passwordRes.token,
        canRoute: true,
      });
      isAuthScc = true;
    } else if (passwordRes.result === AuthResults.OTP_AUTH_NEED) {
      isValid = true;
      setHelperText({
        ...helperText,
        otp: { error: false, text: "Please enter the otp" },
      });
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: false,
        isVisible: true,
      });
      // setIsVisible(true);
    } 
    else if (
      passwordRes.result === AuthResults.INCORRECT_PASSWORD
    ) {
      setHelperText({
        ...helperText,
        password: { error: true, text: "Incorrect email address or password" },
        passwordLimit: {
          error: true,
          text: `${passwordRes.limit} tries remaining`,
        },
      });
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: false,
        isVisible: false,
      });
    } 
     else if (
      passwordRes.result === AuthResults.INVALID
    ) {
      setHelperText({
        ...helperText,
        password: { error: true, text: "Incorrect email address or password" },
        // passwordLimit: {
        //   error: true,
        //   text: `${passwordRes.limit} tries remaining`,
        // },
      });
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: false,
        isVisible: false,
      });
    } 
    else if (passwordRes.result === AuthResults.ACCOUNT_LOCKED) {
      setHelperText({
        ...helperText,
        password: {
          error: true,
          text: "User Account is locked, Please Contact DPASCert",
        },
      });
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: false,
        isVisible: false,
      });
    } else if (passwordRes.result === AuthResults.PASSWORD_RESET_NEED) {
      isValid = true;
      isAuthScc = true;
       props.onEnableChangePwd(loginData.userName);
    } else if (passwordRes.result === AuthResults.SERVER_ERROR) {
      setHelperText({
        ...helperText,
        password: {
          error: true,
          text: "Unable to connect to server or No internet",
        },
      });
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: false,
        isVisible: false,
      });
    } 
    else if (passwordRes.result === AuthResults.EXPIRED) {
      setHelperText({
        ...helperText,
        password: {
          error: true,
          text: "Your password has expired",
        },
      });
    }
    else if (passwordRes.result === AuthResults.PASS_RESTRICT) {
      setHelperText({
        ...helperText,
        password: {
          error: true,
          text: "Password must be between 8 and 18 characters",
        },
      });
    } else {
      setHelperText({
        ...helperText,
        password: { error: true, text: "" },
        passwordLimit: { error: false, text: "" },
      });
      // setIsVisible(false);
      setOtpConfig({
        isFirstOtpGenerated: false,
        isOtpEntered: false,
        isVisible: false,
      });
    }

    setOnlySuccessAuthSucc(isAuthScc);
    setPwdValidated(isValid);
  }, [passwordRes.result]);

  // generateOpt handler method
  const generateOtp = async () => {
    try {
      setLoading({
        ArrowLoader: false,
        submitLoader: false,
        generateLoader: true,
      });
      var res = await API_SSO.GenerateOtp(loginData.userName);
      if (res.data) {
        setHelperText({
          ...helperText,
          otp: { error: false, text: "OTP sent to your registered e-mail ID" },
        });
        // setIsGenerate(true);
        setOtpConfig({
          isFirstOtpGenerated: true,
          isOtpEntered: false,
          isVisible: true,
        });
        setLoading({
          ArrowLoader: false,
          submitLoader: false,
          generateLoader: true,
        });
      }
    } catch (error) {
      console.log(error);
    }

    // setAuthenticationResult({
    //   ...authenticationResult,
    //   generateOtp: { res: res, isLoading: isLoading, error: error },
    // });
  };

  // after opt successfully call the onLogin routing
  useEffect(() => {
    if (authSuccess.result && authSuccess.canRoute) {
      SetSSOToken(authSuccess.token);
      onLoginSuccess(loginData.userName, authSuccess.token);
    }
  }, [authSuccess]);

  // method for validate otp
  const validateOtp = async () => {
    var res = await API_SSO.ValidationOtp(loginData.userName, loginData.otp);
    if (res?.data?.result !== undefined) {
      if (res.data.result === AuthResults.DONE) {
        setAuthSuccess({
          result: true,
          token: res.data.token,
          canRoute: true,
        });
      } else if (res.data.result === AuthResults.PASSWORD_RESET_NEED) {
        props.onEnableChangePwd(loginData.userName);
      } else if (res.data.result === AuthResults.INVALID) {
        setHelperText({
          ...helperText,
          otp: { error: true, text: "Incorrect OTP" },
        });
      }
    }
    // setAuthenticationResult({
    //   ...authenticationResult,
    //   validateOtp: { res: res, isLoading: isLoading, error: error },
    // });
  };

  // useEffect for remember me data set
  useEffect(() => {
    var rememberData: any = getRememberMeDetails(CLocalStorage.Keys.RememberMe);
    console.log(rememberData);
    SetRememberMe(rememberData.isChecked);
    if (rememberData.isChecked === true) {
      setLoginData({
        userName: rememberData.UserName,
        password: rememberData.Password,
        otp: "",
      });

      // checkPasswordValidation(rememberData.UserName, rememberData.Password);
    }
  }, [authenticationResult]);

  // useEffect for set the cookies
  useEffect(() => {
    var manager = new CookieManager();
    const cookiesPresent = manager.getCookie(false);
    setIsCookiePresent(cookiesPresent);
    if (cookiesPresent) {
      // window.history.replaceState(null, '', window.location.href);

      // window.addEventListener('popstate', () => {
      //   window.history.forward();
      // });
      var email = sessionStorage.getItem(CLocalStorage.Keys.Email);
      history.replace(CRoutePaths.Applications);
    } else {
      console.log("Error ");
    }

    // return () => {
    //   window.removeEventListener('popstate', () => {
    //     window.history.forward();
    //   });
    // };
    return;
  }, [history]);

  // sumbit otp handler for navigate to home route
  const handleOtpSubmit = async (e: any) => {
    e.preventDefault();
    try {
      setLoading({
        ArrowLoader: false,
        submitLoader: true,
        generateLoader: false,
      });
      performRememberMe(CLocalStorage.Keys.RememberMe, {
        isEnabled: isRememberme,
        userName: loginData.userName,
        password: loginData.password,
      });
      if (isOnlySuccessAuthSucc) {
        if (passwordRes.result === AuthResults.PASSWORD_RESET_NEED) {
          props.onEnableChangePwd(loginData.userName);
        } else {
          setAuthSuccess({
            result: authSuccess.result,
            token: authSuccess.token,
            canRoute: true,
          });
        }
      } else if (otpConfig.isOtpEntered) {
        if (loginData.otp.trim().length > 0) {
          await validateOtp();
          setLoading({
            ArrowLoader: false,
            submitLoader: false,
            generateLoader: false,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // handler method for Reset pwd
  const handleResetPwd = async () => {
    setLoginData({ userName: loginData.userName, otp: "", password: "" });
    setHelperText((prevState) => ({
      ...prevState,
      password: {
        error: false,
        text: "",
      },
    }));

    var res = await API_SSO.ResetPassword(loginData.userName);
    if (res.data.status.includes("SUC:200")) {
      setModalOpen(true);
      setTimeout(() => {
        setModalOpen(false);
      }, 3000);
    } else if (res.data.status.includes("ERR")) {
      var error = "Unable to reset the password";
      res.data.errors.map((err: any) => {
        if (err.message === "emailID") {
          error = "User not found";
        }
      });
      setHelperText({
        ...helperText,
        userName: { error: true, text: error },
      });
    }
  };

  return (
    <>
      <Modal
        title={"Information"}
        open={isModalOpen}
        closeIcon={false}
        onOk={() => {
          setModalOpen(false);
        }}
        // style={style}
        onCancel={() => {
          setModalOpen(false);
        }}
        footer={[]}
        width={600}
        maskClosable={false}
        //afterClose={afterClose}
        //keyboard={keyboard}
        //closable={closable}

        centered={true}
      >
        <label>Temporary password sent to your registered e-mail ID</label>
      </Modal>

      <Stack
        direction={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Stack direction={"row"} justifyContent={"center"} sx={inputDivStyle}>
          <img src={discoverImg} alt="discover-logo" />
        </Stack>
        <div style={inputDivStyle}>
          <GInput
            type="email"
            name="userName"
            value={loginData.userName}
            // error={helperText.userName.error}
            // helperText={helperText.userName.text}
            onChange={onChangeLoginDataHandler}
            // onBlur={() => onUserNameBlur(loginData)}
            label="Email Address"
          />
        </div>
        <div style={pwdInputDivStyle}>
          <GInput
            type={showPwdText ? "text" : "password"}
            name="password"
            value={loginData.password}
            // error={helperText.password.error}
            // helperText={helperText.password.text}
            onChange={onChangeLoginDataHandler}
            // onBlur={() => onPasswordBlur(loginData)}
            label="Password"
            icons={{
              end: (
                <>
                  <span
                    onClick={() => {
                      setShowPwdText(!showPwdText);
                    }}
                    style={
                      loginData.password.length > 0 ? eyeIcon : DisabledeyeIcon
                    }
                  >
                    {showPwdText ? PHIcons.EyeOff : PHIcons.EyeOn}
                  </span>
                  <span
                    style={
                      loginData.userName.length > 0 &&
                      loginData.password.length > 0
                        ? ArrowspanStyle
                        : DisabledArrowIcon
                    }
                    onClick={() => checkPasswordValidation()}
                  >
                    <TrendingFlatIcon style={ArrowIcon} />{" "}
                    {loading.ArrowLoader ? <Loader /> : <></>}
                  </span>
                </>
              ),
            }}
          />
        </div>
        <div
          style={
            loginData.userName?.length > 0 ? inputDivStyle : disabledDivStyle
          }
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginRight: "1rem",
              }}
            >
              {(helperText.userName.error || helperText.password.error) && (
                <div style={errorMsg}>
                  {helperText.userName.text || helperText.password.text}
                </div>
              )}
            </div>
            {helperText.passwordLimit.error && (
              <div style={errorMsg}>{helperText.passwordLimit.text}</div>
            )}
          </div>
        </div>
        {/* <div style={{marginLeft: "70%"}}>
           <span style={forgotspanStyle} onClick={handleResetPwd}>
                Forgot Password?
            </span>
        </div> */}
        <div
          style={
            loginData.userName?.length > 0 ? inputDivStyle : disabledDivStyle
          }
        >
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <span style={forgotspanStyle} onClick={handleResetPwd}>
              Forgot Password
            </span>
          </Stack>
        </div>

        {otpConfig.isVisible ? (
          <div style={inputDivStyle}>
            <div style={otpStyle}>Enter the OTP</div>
            <div style={otpInputDivStyle}>
              {[0, 1, 2, 3].map((index) => (
                <div key={index}>
                  <input
                    type="text"
                    key={index}
                    name={`otp-${index}`}
                    value={loginData.otp.split("")[index] || ""}
                    ref={(el) => (inputsRef.current[index] = el)}
                    onChange={(event) => onChangeOtpHandler(event, index)}
                    maxLength={1}
                    autoComplete="off"
                    style={otpdivStyle}
                  />
                </div>
              ))}
            </div>

            {helperText.otp.error && (
              <span style={helperOtpStyle}>{helperText.otp.text}</span>
            )}
            {!otpConfig.isFirstOtpGenerated ? (
              <div
                onClick={generateOtp}
                style={generateOtpstyle}
                title="Generate"
              >
                Generate OTP{" "}
                {loading.generateLoader ? (
                  <Spin
                    spinning={loading.generateLoader}
                    size="small"
                    style={{ marginLeft: "10px", color: "ButtonFace" }}
                  />
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div style={reGenerate}>
                OTP sent to your registered email. Didn't receive it?
                <span
                  style={{
                    color: "#EC6C2A",
                    borderBottom: "1px solid #EC6C2A",
                    cursor: "pointer",
                    marginLeft:"4px"
                  }}
                  onClick={generateOtp}
                >
                  Click here
                </span>
              </div>
            )}
            <div>
              <button
                onClick={handleOtpSubmit}
                disabled={
                  !otpConfig.isOtpEntered &&
                  !isOnlySuccessAuthSucc &&
                  !isPwdValidated
                }
                style={
                  isPwdValidated &&
                  (otpConfig.isOtpEntered || isOnlySuccessAuthSucc)
                    ? submitButtonStyle
                    : submitDisableButtonStyle
                }
              >
                Submit {loading.submitLoader ? <Loader /> : <></>}
              </button>
            </div>
          </div>
        ) : (
          <Stack
            style={rememberMeStyle}
            direction={"row"}
            justifyContent={"flex-start"}
            spacing={1}
          >
            <input
              style={checkBoxStyle}
              type="checkbox"
              name="isEnabled"
              checked={isRememberme}
              onChange={(e) => SetRememberMe(e.target.checked)}
            />
            <label style={labelElement}>Remember me</label>
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default LoginForm;
